
namespace Matrix.Data {

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.responsive()
    @Serenity.Decorators.panel()
    export class TestDialog extends SiteEntityDialog<TestRow, any> {
        protected getFormKey() { return TestForm.formKey; }
        protected getIdProperty() { return TestRow.idProperty; }
        protected getLocalTextPrefix() { return TestRow.localTextPrefix; }
        protected getNameProperty() { return TestRow.nameProperty; }
        protected getService() { return TestService.baseUrl; }

        protected form = new TestForm(this.idPrefix);

    }
}